import $ from 'jquery';
import 'what-input';
import 'slick-carousel-latest';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
$(document).foundation();



// header

// filters

// card item
$('.button-quantity-add').click(function() {
    var $input = $(this).parent('.item-quantity').find('.input-number');
    var val = parseInt($input.val(), 10);
    $input.val(val + 1);
});

$('.button-quantity-remove').click(function() {
    var $input = $(this).parent('.item-quantity').find('.input-number');
    var val = parseInt($input.val(), 10);
    $input.val(val - 1);

})




// hover item card 
$(".item-detail").mouseenter(function() {
    $(this).parent().find('.item-callout-card').fadeIn();
});  
$(".item-callout-card").mouseleave(function() {
    $(this).fadeOut();
});

// hover item card 
$(".result-item-detail").mouseenter(function() {
    $(this).find('.result-item-callout-card').fadeIn();
});  
$(".result-item-callout-card").mouseleave(function() {
    $(this).fadeOut();
});



/* Slick Slider Product Page
 */

$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
});

$('.slider-nav').slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true
});

$('a[data-slide]').click(function(e) {
    e.preventDefault();
    var slide_number = $(this).data('slide');
    $('.slider-nav').slick('slickGoTo', slide_number - 1);
});

$('.product-accessories-slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
});

$('.product-avalaible-slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
});

$('.product-similar-slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
});


